import { Slider as AntSlider } from "antd"
import { Number, Text } from ".."
import { useEffect, useMemo, useState } from "react"
import { debounce } from "lodash"

const Slider = props => {
  const {
    range,
    isCurrency,
    onChange = () => {},
    value = [],
    label,
    className,
    labelProps,
    debounceDelay = null,
    ...rest
  } = props

  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const debouncedOnChange = useMemo(
    () => (debounceDelay ? debounce(onChange, debounceDelay) : onChange),
    [debounceDelay, onChange]
  )

  const handleChange = newValue => {
    setLocalValue(newValue)
    debouncedOnChange(newValue)
  }

  const marks = useMemo(
    () => ({
      [range?.[0]]: {
        label:
          localValue?.[0] != null ? (
            <Number digitAfterFraction={1} isStringOnly isCurrency={isCurrency} value={localValue[0]} />
          ) : undefined,
      },
      [range?.[1]]: {
        label:
          localValue?.[1] != null ? (
            <Number digitAfterFraction={1} isStringOnly isCurrency={isCurrency} value={localValue[1]} />
          ) : undefined,
      },
    }),
    [range, localValue]
  )

  return (
    <>
      {label && (
        <Text type="secondary" {...labelProps}>
          {label}
        </Text>
      )}
      <AntSlider
        className={className}
        range
        marks={marks}
        min={range[0]}
        max={range[1]}
        onChange={handleChange}
        value={localValue}
        tooltip={{ formatter: value => <Number isStringOnly isCurrency={isCurrency} value={value} /> }}
        {...rest}
      />
    </>
  )
}

export default Slider
